import PACAA010 from '../../pages/Auth/PACAA010';
import PAIAB030 from '../../pages/MyPage/PAIAB030';
import PAJAC050 from '../../pages/MyPage/PAJAC050';
import PAJAC051 from '../../pages/MyPage/PAJAC051';
import PAFAA060 from '../../pages/Resume/PAFAA060';
import withLogged from '../../shared/hocs/WithLogged';
import withNotLogged from '../../shared/hocs/WithNotLogged';

const routerOther = [
    { path: '/login', element: withLogged(PACAA010) },
    { path: '/pajac050-:id', element: withNotLogged(PAJAC050) },
    { path: '/pajac051-:id', element: PAJAC051 },
    { path: '/paiab030-:id', element: PAIAB030 },
    { path: '/pafaa061-:id', element: PAFAA060 },
];

export default routerOther;
